import React, { useState } from "react";
import SVG from "react-inlinesvg";
import { t } from "ttag";

import iconXClose from "../../../../img/icons/x-close.svg";
import { RichText } from "../../../common/RichText";
import { IBasketLineAdvertistingContent } from "../../../models/catalogue.interfaces";

import styles from "./common.module.scss";

export const BasketLineUpsellMessage = (props: {
    content: IBasketLineAdvertistingContent;
}): React.ReactNode => {
    const [isHidden, setIsHidden] = useState(false);
    return (
        <div
            className={styles.offerUpsellMessageOuter}
            style={{ display: isHidden ? "none" : "block" }}
        >
            <div className={styles.offerUpsellMessage}>
                <button
                    className={styles.offerUpsellCloseButton}
                    // TODO(i18n): Use sentence case for UI strings: t`Close` instead of t`close`
                    aria-label={t`close`}
                    onClick={() => {
                        setIsHidden(true);
                    }}
                >
                    <SVG
                        aria-hidden="true"
                        className={styles.offerUpsellCloseIcon}
                        src={iconXClose}
                        // TODO(i18n): Inconsistent casing - use consistent sentence/title case across UI strings
                        title={t`Close Icon`}
                    />
                </button>
                <RichText html={props.content.content} />
            </div>
        </div>
    );
};
